import type { Locale } from '../../localization/i18n'

interface Props {
  date: Date
  locale: Locale
  options?: Intl.DateTimeFormatOptions
}

const formatDate = ({ date, locale, options }: Props) =>
  date.toLocaleDateString(locale, {
    ...options,
  })

export default formatDate
